(ns lemonpi.domain.interface.asset
  (:require [lemonpi.schema.interface :as schema]
            [malli.util :as mu]))

(def root-asset-id 1)

(def supported-file-types
  {:image #{"jpg" "jpeg" "avif" "png" "gif" "svg" "webp"}
   :video #{"mp4" "mov" "m4v" "webm"}
   :audio #{"wav" "mp3" "aif"}
   :model #{"hdri" "obj" "fbx" "exr" "hdr" "glb"}
   :fonts #{"ttf" "otf" "woff" "woff2"}
   :code #{"js" "css"}})

(schema/register! :asset-tree/id :int)
(schema/register! :asset-tree/name :string)
(schema/register! :asset-tree/parent-id :int)
(schema/register! :asset-tree/advertiser-id :int)
(schema/register! :asset-tree/folder-type [:enum "root" "assets" "fonts" "logos" "templates" "user"])

(schema/register! ::asset-folder
  [:map
   [:asset-tree/id]
   [:asset-tree/name]
   [:asset-tree/parent-id]
   [:asset-tree/advertiser-id]
   [:asset-tree/folder-type {:optional true}]
   [:children {:optional true} [:vector [:ref ::asset-folder]]]])

(schema/register! ::new-asset-folder
  [:map {:closed true}
   [:asset-tree/name]
   [:asset-tree/parent-id]
   [:asset-tree/advertiser-id]])

(schema/register! ::simple-folder
  [:map {:closed true}
   :asset-tree/name
   [:children {:optional true} [:sequential [:ref ::simple-folder]]]])

(schema/register! :asset/id uuid?)
(schema/register! :asset/asset-tree-id :asset-tree/id)
(schema/register! :asset/advertiser-id :int)
(schema/register! :asset/name :string)
(schema/register! :asset/slug :string)
(schema/register! :asset/mime-type [:maybe :string])
(schema/register! :asset/digest [:maybe :string])
(schema/register! :asset/file-size :int)
(schema/register! :asset/upload-status [:maybe :string])
(schema/register! :asset/original-filename :string)
(schema/register! :asset/created-at inst?)
(schema/register! :asset/updated-at inst?)
(schema/register! :asset/created-by :int)
(schema/register! :asset/updated-by :int)
(schema/register! :asset/archived :boolean)
(schema/register! :asset/key-url :string)
(schema/register! :asset/path-url :string)
(schema/register! :asset/thumbnail-url :string)
(schema/register! :font-family/id uuid?)
(schema/register! :font-family/display-name :string)
(schema/register! :font-family/original-name :string)
(schema/register! :font-family/advertiser-id :int)
(schema/register! :font-family/created-on inst?)
(schema/register! :font-family/created-by :int)

;; Nil or flat map, known fields have specific types,
;; other field value can be string or a number.
(schema/register! :asset/metadata
  [:maybe
   (mu/merge
    (mu/optional-keys
     [:map
      {:closed true}
      [:font-family :string]
      [:font-weight :int]
      [:font-style :string]])
    [:map-of :keyword [:or :string :int :double]])])

(schema/register! :asset/asset
  [:map
   :asset/id
   :asset/asset-tree-id
   :asset/advertiser-id
   :asset/name
   :asset/slug
   :asset/mime-type
   :asset/digest
   :asset/file-size
   :asset/original-filename
   [:asset/key-url {:optional true}]
   [:asset/path-url {:optional true}]
   [:asset/thumbnail-url {:optional true}]
   [:asset/archived {:optional true}]
   :asset/created-at
   :asset/updated-at
   :asset/created-by
   :asset/updated-by
   [:asset/metadata {:optional true}]])

(schema/register! :asset/font-family
  [:map {:closed true}
   :font-family/id
   :font-family/original-name
   :font-family/display-name
   :font-family/advertiser-id
   :font-family/created-on
   :font-family/created-by])

(schema/register! :asset/new-asset
  [:map {:closed true}
   :asset/asset-tree-id
   :asset/advertiser-id
   :asset/name
   :asset/file-size
   :asset/original-filename
   [:asset/archived {:optional true}]
   [:asset/metadata {:optional true}]])

(schema/register! :asset/new-font-asset
  [:map
   {:closed false}
   [:asset/metadata
    [:map
     {:closed false}
     [:font-family [:string {:min 1}]]
     [:font-weight [:enum 100 200 300 400 500 600 700 800 900]]
     [:font-style [:enum "" "italic"]]]]])
